import { buildDocument, parseDocument, stringifyDocument } from '../format/inkfmt';
import type { DeviceInfo } from '../model/types';
import type { ImportResult, Repo } from './repo';

export const BACKUP_KIND = 'backup' as const;

/** Every notebook (deleted ones included) as one inkfmt/v1 JSON string. */
export async function backupAll(repo: Repo, device?: DeviceInfo): Promise<string> {
  const all = await repo.exportAll();
  return stringifyDocument(buildDocument(all, BACKUP_KIND, device));
}

/** Merges an inkfmt/v1 file (backup or single-notebook export) into the database. */
export async function restoreFrom(repo: Repo, text: string): Promise<ImportResult> {
  const { records } = parseDocument(text);
  return repo.importRecords(records);
}

export function backupFilename(d = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `inkbook-backup-${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}.inkfmt.json`;
}
